import {createSelector} from "reselect";
import {getAdminStoreState} from "../../store/admin-store-selectors";

export class ChannelsSelectors {
    static readonly state = createSelector(getAdminStoreState, state => state.channels);

    static readonly channels = createSelector(ChannelsSelectors.state, state => state.channels);

    static readonly initialized = createSelector(ChannelsSelectors.state, state => state.initialized);
    static readonly error = createSelector(ChannelsSelectors.state, state => state.error);
}
